/*#__NO_SIDE_EFFECTS__*/
export const noop = <T>(any: T): T => any
